export const iconFontAwesomeMusicVideoMicrophone = (
	<i className="fa-solid fa-microphone"></i>
);
